var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-links"},[_c('a',{staticClass:"terms-links__item",attrs:{"href":_vm.termsPageUrl}},[_vm._v("Умови користування")])])}
var staticRenderFns = []

export { render, staticRenderFns }